"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsManager = void 0;
const core_1 = require("../core");
const LOG_PREFIX = '[Translations Manager]';
class TranslationsManager {
    constructor({ baseVersion, provider, storage }) {
        this.provider = provider;
        this.storage = storage;
        this.baseVersion = baseVersion;
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.storage.sync(this.baseVersion);
                let providedTranslations;
                const isEmpty = this.storage.isEmpty();
                if (isEmpty) {
                    core_1.Log.info(LOG_PREFIX + ' - getting base version:', this.baseVersion);
                    providedTranslations = yield this.provider.get(this.baseVersion, true);
                    if (providedTranslations !== undefined) {
                        yield this.storage.set(providedTranslations);
                    }
                }
                else {
                    core_1.Log.info(LOG_PREFIX + ' - getting from stored version:', this.storage.getVersion());
                    const newTranslations = yield this.provider.get(this.storage.getVersion());
                    if (newTranslations !== undefined) {
                        yield this.storage.update(newTranslations);
                    }
                    providedTranslations = yield this.storage.get();
                }
                return Promise.resolve(providedTranslations);
            }
            catch (e) {
                core_1.Log.warn(LOG_PREFIX + ' - failure getting translations');
                return Promise.reject(e);
            }
        });
    }
}
exports.TranslationsManager = TranslationsManager;
//# sourceMappingURL=translationsManager.js.map